import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useLazyGetDevicesQuery } from '../../../api/deviceApiSlice';
import Block from '../../../components/Block';
import Icon from '../../../components/Icon';
import Pagination from '../../../components/tables/Pagination';
import Table from '../../../components/tables/Table';
import useAsyncTable from '../../../components/tables/useAsyncTable';
import Title from '../../../components/Title';

const DevicesList = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [devicesList] = useLazyGetDevicesQuery()

  const {
    tableProps,
    paginationProps,
    tableFilterProps
  } = useAsyncTable({
    sortable: true,
    paginate: true,
    sortBy: {id: 'desc'},
    callback: devicesList
  })
  const { filter, setFilter } = tableFilterProps;
  const onRowClick = (data) => {
    history.push(`/devices/${data.spt_id}`);
  }
  const columns = [
    {
      Header: 'Id',
      accessor: 'id',
      disableFilters: true
    },
    {
      Header: 'idfa',
      accessor: 'idfa',
      disableFilters: false
    },
    {
      Header: 'spt_id',
      accessor: 'spt_id',
      disableFilters: false
    },
    {
      Header: 'os',
      Cell: ({row}) => (row.original.os ? <Icon icon={row.original.os}/> : <></>),
      accessor: 'os',
      filter: 'select',
      options: ["ios", "android"],
      disableFilters: false
    },
    {
      Header: 'Application',
      accessor: 'bundle_id',
      disableFilters: false
    },
    {
      Header: 'Created At',
      accessor: 'created_at',
      disableFilters: true,
      format: 'date'
    }
  ];

  useEffect(() => {
    console.log(filter);
  }, [filter])

  return (
    <>
      <Title main={t("menu.devices")}/>
      <Block className="mb-0" style={{overflow: "initial"}}>
        <Table
          columns={columns}
          onRowClick={onRowClick}
          {...tableProps}/>
      </Block>
      <Pagination {...paginationProps}/>
    </>
  );
}

export default DevicesList;
